// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"oY-z","upvoteIcon":"pY-z","downvoteIcon":"qY-z","feedbackIcon":"rY-z"};